import { isFilledByUs } from "@/lib/attributeReview/noFieldPick";
import { leafLabel } from "@/lib/attributeReview/kindWords";
import type { WorkChipView } from "@/lib/attributeReview/rowChips";
import {
  asReviewRow,
  type RowInput,
} from "@/lib/attributeReview/reviewRow.types";

import { WorkChip } from "./WorkChip";

export function SuggestionCell({
  row: input,
  chips,
}: {
  row: RowInput;
  chips: WorkChipView[];
}) {
  const row = asReviewRow(input);
  const path = row.pathPreview ? String(row.pathPreview) : null;
  return (
    <div className="min-w-0 space-y-1">
      {path ? (
        <>
          <p className="font-mono text-xs text-slate-900 [overflow-wrap:anywhere] dark:text-slate-100">
            {path}
          </p>
          {row.leaf ? (
            <p className="text-xs text-slate-500 dark:text-slate-400">
              {leafLabel(String(row.leaf))}
            </p>
          ) : null}
        </>
      ) : (
        <p className="text-xs text-slate-400 dark:text-slate-500">
          {isFilledByUs(row.kind) ? "System field" : "No pick yet"}
        </p>
      )}
      {chips.length > 0 && (
        <div className="flex flex-wrap gap-1">
          {chips.map((chip) => (
            <WorkChip key={chip.text} chip={chip} />
          ))}
        </div>
      )}
    </div>
  );
}
